<template>
    <p> Aufgaben name </p>
</template>



<script>

</script>


<style scoped>

</style>
